import { render, staticRenderFns } from "./MapIconProductGlobus.vue?vue&type=template&id=3d0450b0&scoped=true&"
import script from "./MapIconProductGlobus.vue?vue&type=script&lang=js&"
export * from "./MapIconProductGlobus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0450b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d0450b0')) {
      api.createRecord('3d0450b0', component.options)
    } else {
      api.reload('3d0450b0', component.options)
    }
    module.hot.accept("./MapIconProductGlobus.vue?vue&type=template&id=3d0450b0&scoped=true&", function () {
      api.rerender('3d0450b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/icons/MapIconProductGlobus.vue"
export default component.exports